import type { Database } from 'sql.js';
import type { RedencionBonoListItem } from '../../../domain/redencionBonoModel.ts';
import { rowToRedencionListItem } from './mappers.ts';

export const REDENCION_LIST_SQL = `SELECT r.id, r.public_id, r.entrega_id, r.es_remanente, r.fecha_hora AS fecha, r.proveedor_id,
              r.responsable_id, r.latitud, r.longitud, r.offline_uploaded_at,
              u.nombre AS responsable_nombre,
              COALESCE(p.nombre, '') AS proveedor_nombre,
              (SELECT COUNT(*) FROM redencion_bono_participante rbp WHERE rbp.redencion_bono_id = r.id) AS total_participantes
       FROM redenciones_bono r
       LEFT JOIN entregas e ON e.id = r.entrega_id
       LEFT JOIN proveedores p ON p.id = r.proveedor_id
       LEFT JOIN usuarios u ON u.id = r.responsable_id`;

/** Lists all redemptions from the database. */
export function listRedencionesBono(db: Database): RedencionBonoListItem[] {
  const st = db.prepare(`${REDENCION_LIST_SQL} ORDER BY r.fecha_hora DESC, r.id DESC`);
  const out: RedencionBonoListItem[] = [];
  try {
    while (st.step()) {
      const o = st.getAsObject();
      out.push(rowToRedencionListItem(o));
    }
  } finally {
    st.free();
  }
  return out;
}

/** Retrieves a redemption by its ID. */
export function getRedencionById(db: Database, id: number): RedencionBonoListItem | null {
  const st = db.prepare(`${REDENCION_LIST_SQL} WHERE r.id = ? LIMIT 1`);
  try {
    st.bind([id]);
    if (!st.step()) return null;
    return rowToRedencionListItem(st.getAsObject());
  } finally {
    st.free();
  }
}

/** Lists redemptions already reported by a successful offline sync upload. */
export function listRedencionesUploadedOfflineInDb(db: Database): RedencionBonoListItem[] {
  const st = db.prepare(
    `${REDENCION_LIST_SQL} WHERE r.offline_uploaded_at IS NOT NULL AND trim(r.offline_uploaded_at) != '' ORDER BY r.fecha_hora DESC, r.id DESC`,
  );
  const out: RedencionBonoListItem[] = [];
  try {
    while (st.step()) {
      const o = st.getAsObject();
      out.push(rowToRedencionListItem(o));
    }
  } finally {
    st.free();
  }
  return out;
}
